import React from 'react'
import { Route, Routes } from 'react-router'
import Container from 'src/components/Container'
import { Formik, Form } from 'formik'
import FormField from 'src/components/FormField'
import FormLabel from 'src/components/FormLabel'
import { BannerText, CharacterCount, BigTextArea } from './styled'
import { RoleGate } from 'src/components/Roles'
import { useSendCrisisNotificationMutation } from 'shared/schema'

function CrisisNotificationsHome() {
	const [sendCrisisNotification] = useSendCrisisNotificationMutation()
	const MAX_CHARACTERS = 1000;
	return (
		<Container>
			<RoleGate role="Crisis">
				<BannerText>Only use in the case of crisis like fire or active shooter.</BannerText>
				<BannerText>
					NOT TO BE USED for standard emergencies like utility strikes, injuries, or property damage
					unless catastrophic in nature.
				</BannerText>
				<BannerText>Please note: Text message are limited to {MAX_CHARACTERS} characters including spaces.</BannerText>
				<Formik
							initialValues={{
								message: ''
							}}
							validate={(values) => {
								const errors: { message?: string } = {}
								if (!values.message) {
									errors.message = 'Message is required'
								} else if (values.message.length > MAX_CHARACTERS) {
									errors.message = `Message exceeds ${MAX_CHARACTERS} character limit (${values.message.length} characters)`
								}
								return errors
							}}
							onSubmit={async (values, actions) => {
								try {
									const result = await sendCrisisNotification({
										variables: {
											title: 'Crisis Notification',
											text: values.message
										}
									})

									if (result.data?.sendCrisisNotification?.success) {
										alert('Crisis notification sent successfully!')
										actions.resetForm()
									} else {
										throw new Error(result.data?.sendCrisisNotification?.message || 'Failed to send crisis notification')
									}
								} catch (error) {
									console.error('Error sending crisis notification:', error)
									alert(`Failed to send crisis notification: ${error instanceof Error ? error.message : 'Unknown error'}`)
								} finally {
									actions.setSubmitting(false)
								}
							}}
						>
							{({ values, errors, touched, isValid, isSubmitting }) => {
								const isOverLimit = (values.message || '').length > MAX_CHARACTERS
								return (
									<Form>
										<div style={{ width: '90%', paddingTop: '20px' }}>
											<FormLabel>Crisis Message</FormLabel>
											<BigTextArea
												name="message"
												component="textarea"
												placeholder="Enter your crisis notification message..."
											/>
										</div>
										<CharacterCount isOverLimit={isOverLimit}>
											{(values.message || '').length} / {MAX_CHARACTERS} characters
										</CharacterCount>
										{errors.message && touched.message && (
											<div style={{ color: '#e21717', marginTop: '0.5rem', fontSize: '0.9rem', width: '90%' }}>
												{errors.message}
											</div>
										)}
										<FormField
											type="formButtons"
											submitLabel="Send"
											disabled={isOverLimit}
											isLoading={isSubmitting}
										/>
									</Form>
								)
							}}
						</Formik>
			</RoleGate>
		</Container>
	)
}

function CrisisNotificationsRoute() {
	return (
		<Routes>
			<Route path="/" element={<CrisisNotificationsHome />} />
		</Routes>
	)
}

export default CrisisNotificationsRoute
